import { z } from 'zod';
import { formSchemaSchema } from './form-schema.js';
import { brandingSchema } from './branding.js';

export const templateSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, 'Name ist ein Pflichtfeld').max(200),
  art: z.string().min(1, 'Art ist ein Pflichtfeld').max(100),
  beschreibung: z.string().max(1000).optional(),
  aktiv: z.boolean().optional(),
  /** System-Templates sind schreibgeschützt und werden zum Anpassen kopiert. */
  system: z.boolean().optional(),
  aktuelleVersionId: z.string().nullable().optional(),
});
export type TemplateKopf = z.infer<typeof templateSchema>;

export const templateVersionSchema = z.object({
  id: z.string().optional(),
  templateId: z.string().min(1),
  version: z.number().int().min(1),
  formSchema: formSchemaSchema,
  layoutHtml: z.string().min(1, 'Layout-HTML darf nicht leer sein'),
  layoutCss: z.string(),
  branding: brandingSchema,
  erstelltAm: z.string().min(1),
  erstelltVon: z.string().min(1),
});
export type TemplateVersion = z.infer<typeof templateVersionSchema>;

/**
 * Eingabe zum Anlegen einer neuen Version. Eine bestehende Version wird nie
 * überschrieben (CLAUDE.md §3.2) — Speichern erzeugt immer eine neue.
 */
export const neueTemplateVersionSchema = templateVersionSchema.omit({
  id: true,
  version: true,
  erstelltAm: true,
  erstelltVon: true,
});
export type NeueTemplateVersion = z.infer<typeof neueTemplateVersionSchema>;
